import { render, staticRenderFns } from "./DeviceDetailDevice.vue?vue&type=template&id=18eb72a6&"
import script from "./DeviceDetailDevice.vue?vue&type=script&lang=ts&"
export * from "./DeviceDetailDevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports